// src/hooks/currencies/useGetCurrency.js
import { useQuery } from "@tanstack/react-query";
import { getCurrency } from "../../api/apiCurrencies";

function useGetCurrency(id) {
    const { isLoading, error, data } = useQuery({
        queryKey: ["currency", id],
        queryFn: () => getCurrency(id),
        enabled: !!id,
    });

    return { isLoading, error, currency: data?.data || null };
}

export default useGetCurrency;
